import React from "react";
import { Provider } from "react-redux";
import ReduxToastr from "react-redux-toastr";
import store from "./redux/store/index";
import Routes from "./routes/Routes";
import ProfileContextProivder from "./context/profile";
// import { registerServiceWorker } from "./utils/serviceWorkerRegistration";

class App extends React.Component {
  componentDidMount() {
    // Remove `active` className from `.splash` element in `public/index.html`
    !document.querySelector(".splash") || document.querySelector(".splash").classList.remove("active");

    // Register service worker
    // registerServiceWorker();
  }

  render() {
    return (
      <ProfileContextProivder>
        <Provider store={store}>
          <style>
            {
              `
              .wizard .tabs .active{
              background:rgba(59, 124, 221, 0.08);
              }

               .wizard .tabs .active h6{
              font-weight: 500;
              }
               .table-responsive .table thead {
    position: sticky;
    top: 0;
    background: #fff;
    z-index: 1;
  }
    .select__menu, .react-datepicker-popper{
    z-index: 1000;
    }

    .select__control--is-disabled{
    min-height: auto;
    }

    .wrapper::before{
    height: 220px !important;
    }

     .react-datepicker-wrapper {
          width: 100%;
        }
        .custom-table-2 tfoot tr {
      position: sticky;
      bottom: 0;
      z-index: 2;
      background: #fff;
      border-top: 2px solid #dee2e6;
      box-shadow: 0 -2px 6px rgba(60,72,88,0.04);
    }
    .custom-table-2 tfoot td {
      background: #fff;
      font-weight: 700;
      color: #212529;
      border-top: 2px solid #dee2e6;
      border-bottom: none;
      font-size: 1.01rem;
    }
              `
            }
          </style>
          <Routes />
          <ReduxToastr timeOut={5000} newestOnTop={true} position="top-right" transitionIn="fadeIn" transitionOut="fadeOut" progressBar closeOnToastrClick />
        </Provider>
      </ProfileContextProivder>
    );
  }
}

export default App;
